import { ReactElement } from 'react';
import { Form, Select, DatePicker, TimePicker, Card, Button } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { DateTime } from './RecordingForm.style';
import { FormValues } from '../../types';

interface SelectOption {
  value: number;
  label: string;
}

interface Props {
  advisorOptions: SelectOption[];
  customerOptions: SelectOption[];
  selectedFile: File | null;
  onSubmit: (values: FormValues) => Promise<void>;
  loading?: boolean;
}

const RecordingForm = ({
  advisorOptions,
  customerOptions,
  selectedFile,
  onSubmit,
  loading = false,
}: Props): ReactElement => {
  const [form] = Form.useForm<FormValues>();

  const handleFinish = (values: FormValues): void => {
    void onSubmit(values);
  };

  return (
    <Card title='録音情報'>
      <Form form={form} layout='vertical' onFinish={handleFinish}>
        <Form.Item
          label='営業担当者'
          name='advisorId'
          rules={[{ required: true, message: '営業担当者名を選択してください' }]}
        >
          <Select
            placeholder='営業担当者名を選択してください'
            options={advisorOptions}
            showSearch
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            disabled={loading}
          />
        </Form.Item>
        <Form.Item label='顧客名' name='customerId' rules={[{ required: true, message: '顧客名を選択してください' }]}>
          <Select
            placeholder='顧客名を選択してください'
            options={customerOptions}
            showSearch
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            disabled={loading}
          />
        </Form.Item>
        <DateTime>
          <Form.Item
            label='面談日'
            name='meetingDate'
            rules={[{ required: true, message: '面談日を選択してください' }]}
          >
            <DatePicker style={{ width: '100%' }} disabled={loading} />
          </Form.Item>
          <Form.Item
            label='面談時間'
            name='meetingTime'
            rules={[{ required: true, message: '面談時間を選択してください' }]}
          >
            <TimePicker format='HH:mm' style={{ width: '100%' }} disabled={loading} />
          </Form.Item>
        </DateTime>
        <Form.Item>
          <Button type='primary' icon={<SaveOutlined />} loading={loading} disabled={!selectedFile} htmlType='submit'>
            保存
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default RecordingForm;
